// VARIANT COMPONENTS
export { ActionsDropdown } from './actions/main';
export { ListDropdown } from './list/main';


// TYPES

// Variant TYPES - Actions
export enum ActionsOpenDirections {
  DownLeft = 'down-left',
  DownRight = 'down-right',
  UpLeft = 'up-left',
  UpRight = 'up-right',
}
export enum ActionsDropdownTransitions {
  FadeInTranslate = 'fade-in-translate',
  FadeIn = 'fade-in',
}

// Variant TYPES - List
export enum ListOpenDirections {
  Up = 'up',
  Down = 'down',
}
export enum ListDropdownTransitions {
  FadeIn = 'fade-in',
}
export type ListOptionValue = string | number;
export interface ListOption {
  label: ListOptionValue;
  value: ListOptionValue;
  isDisabled?: boolean;
}
export enum DropdownNavigateKeys {
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Enter = 'Enter',
}


// Base TYPES
export type OpenDirections = ActionsOpenDirections | ListOpenDirections
export enum UserDevices {
  Mobile = 'mobile-view',
  Tablet = 'tablet-view',
  Desktop = 'desktop-view',
}
export type DropdownTransitions = ActionsDropdownTransitions | ListDropdownTransitions
